import { Component, computed, inject, input } from '@angular/core';
import { FilterObject } from '@it2go/data-grid';
import { BaseDialogService } from '../../../../../../components/kit/base-dialog/base-dialog-service';
import { ProfileMessagesComponent } from '../../../profile-page/profile-messages/profile-messages.component';
import { UserMessageDialogWidgetComponent } from './user-message-dialog-widget.component';

@Component({
    selector: 'app-user-messages-widget',
    templateUrl: './user-messages-widget.component.html',
    styleUrl: './user-messages-widget.component.scss',
    imports: [
        ProfileMessagesComponent,
    ],
})
export class UserMessagesWidgetComponent {

    private readonly dialogService = inject(BaseDialogService);

    public items = input<{ serviceId: string, widget: any }[]>([]);

    protected readonly additionalFilter = computed<FilterObject[][]>(() => {
        const days = Math.max(0, ...this.items().map((it) => it.widget?.days ?? 0));
        if (!days) {
            return [];
        }
        const d = new Date();
        d.setDate(d.getDate() - days);
        return [[{ column: 'createdAt', operator: 'GTE', value: [d.toISOString()] }]];
    });

    protected readonly openDetail = (item: any): void => {
        this.dialogService.open(UserMessageDialogWidgetComponent, {
            header: item?.title,
            styleClass: 'p-dialog-width-50',
            data: { id: item.id },
        });
    };
}
